import React from 'react';

import { Card as CardComponent } from './styles';

export default function Card({
  children,
  height = 'full',
  padding = '15px 0 15px 0',
}) {
  return (
    <CardComponent height={height} $padding={padding}>
      {children}
    </CardComponent>
  );
}

// Card.defaultProps = {
//   height: 'full',
//   padding: '15px 0 15px 0',
// };
